export default __webpack_public_path__ + "static/media/logo-w.04582ff2.png";